// src/utils/errorHandler.ts
import { ElNotification } from 'element-plus';

export enum ErrorCode {
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    InternalServerError = 500,
    BadGateway = 502,
    LLMServiceError = 300003,
    ConversationNotFound = 200001,
    MessageNotFound = 200002,
    GeneralError = 100000,
    NotLoggedIn = 401001,
    // Add more error codes as needed
  }

  export function errorHandler(status: number, errorMessage: string) {
    let message = '';
    switch (status) {
      case ErrorCode.BadRequest:
        message = '语义有误';
        break;
      case ErrorCode.Unauthorized:
        message = '服务器认证失败';
        break;
      case ErrorCode.Forbidden:
        message = '服务器拒绝访问';
        break;
      case ErrorCode.NotFound:
        message = '地址错误';
        break;
      case ErrorCode.InternalServerError:
        message = '服务器遇到意外';
        break;
      case ErrorCode.BadGateway:
        message = '服务器无响应';
        break;
        case ErrorCode.LLMServiceError:
          message = 'LLM service error';
          break;
        case ErrorCode.ConversationNotFound:
          message = 'Conversation Not Found';
          break;
        case ErrorCode.MessageNotFound:
          message = 'Message Not Found';
          break;
        case ErrorCode.GeneralError:
          message = 'General Error';
          break;
        case ErrorCode.NotLoggedIn:
          message = 'User not logged in';
          break;
      default:
        message = errorMessage || '发生错误';
        break;
    }
    ElNotification({
      message: `${message}\n错误码: ${status}`,
      type: 'error',
      duration: 3000,
    });
  }

export default errorHandler;